// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.SettingsLeftMenu.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from 'react';
import ContextMenu from 'share/components/layout/Izenda.ContextMenu';
import connect from 'share/enhancers/Izenda.Connect';
import LicenseInfo from 'logic/models/Izenda.LicenseInfo';
import { Integration } from 'config';
import PermissionConstants from 'logic/data/Izenda.PermissionConstants';
import actions from './Izenda.SettingsLeftMenuActions';
import RouteUtils from 'share/utils/Izenda.RouteUtils';
import { head } from 'lodash/fp';
import { observe } from 'mobx';
import uiState from 'logic/Izenda.UiState.js';

@connect(actions)
export default class SettingsLeftMenu extends Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    hasSetupDatabase: PropTypes.bool
  };

  constructor(props: any) {
    super(props);
    if (props.menu.length === 0) {
      props.router.push(RouteUtils.getNoPermissionUrl());
    } else {
      props.updateActiveLink(head(props.menu));
    }

    this.systemModeObserver = observe(uiState, 'systemMode', () => {
      props.updateMenu(props.getLeftMenu());
    });
  }

  componentWillUnmount() {
    this.systemModeObserver();
  }

  /**
   * Render icon
   * @param {Object} item
   */
  renderChangedIcon = (item: any) => {
    const localization = this.props.localization;
    return item.isDirty && item.key !== PermissionConstants.DataSetup ? (
      <span
        className="icon-attention warning-color"
        title={localization.getText('CONNECTION_DETECT_CHANGE_ICON_TOOLTIP')}
      />
    ) : null;
  };

  render() {
    const isActiveLicense = Integration ? LicenseInfo.integrationActiveLicense : LicenseInfo.isActiveLicense;
    const { activeLink, menuStatus } = this.props.store.contextMenu;

    return (
      <ContextMenu
        dataSource={this.props.menu}
        activeKey={activeLink}
        enabled={menuStatus && isActiveLicense}
        onSelected={this.props.changeActiveKey}
        renderChangedIcon={this.renderChangedIcon}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/Izenda.SettingsLeftMenu.js